const AccordianOpen = ({clr}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 6" width={8} height={6} fill="none">
    <path
      fill={clr || "#FFFDEA"}
      d="M3.983 2.046.691 5.338 0 4.647 3.983.663 8 4.647l-.691.69"
    />
  </svg>
)

export default AccordianOpen